/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * User display info for assignment badges
 * @export
 * @interface AdmissionsBoardResponseUsersValue
 */
export interface AdmissionsBoardResponseUsersValue {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    initials: string;
    /**
     * 
     */
    photo_url?: string;
    /**
     * 
     */
    is_deactivated: boolean;
}

/**
 * Check if a given object implements the AdmissionsBoardResponseUsersValue interface.
 */
export function instanceOfAdmissionsBoardResponseUsersValue(value: object): value is AdmissionsBoardResponseUsersValue {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('initials' in value) || value['initials'] === undefined) return false;
    if (!('is_deactivated' in value) || value['is_deactivated'] === undefined) return false;
    return true;
}

export function AdmissionsBoardResponseUsersValueFromJSON(json: any): AdmissionsBoardResponseUsersValue {
    return AdmissionsBoardResponseUsersValueFromJSONTyped(json, false);
}

export function AdmissionsBoardResponseUsersValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionsBoardResponseUsersValue {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'display_name': json['display_name'],
        'initials': json['initials'],
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
        'is_deactivated': json['is_deactivated'],
    };
}

export function AdmissionsBoardResponseUsersValueToJSON(json: any): AdmissionsBoardResponseUsersValue {
    return AdmissionsBoardResponseUsersValueToJSONTyped(json, false);
}

export function AdmissionsBoardResponseUsersValueToJSONTyped(value?: AdmissionsBoardResponseUsersValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display_name': value['display_name'],
        'initials': value['initials'],
        'photo_url': value['photo_url'],
        'is_deactivated': value['is_deactivated'],
    };
}

